import { render, staticRenderFns } from "./VatDetails.vue?vue&type=template&id=524182b0"
import script from "./VatDetails.vue?vue&type=script&lang=js"
export * from "./VatDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports